import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { environment } from '../../../environments/environment';
import { DocumentUploadResponse } from '../models/document-upload-response';
import { ReferralContact } from '../models/referral-contacts';
import { ActionDocuments } from '../models/action-documents'
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class UploadDocumentService {

    baseURL = 'api/Document'
    constructor(private dataService: DataService) {
    }


    downlaodFile(conflictId: number, check: string) {
        return this.dataService.downloadRawFile(`${this.baseURL}/generate-pdf?conflictId=${conflictId}&check=${check}`);
    }

    saveFile(data: any) {
        let fileMeta: string = data.headers.get("File-Name");
        let fileType: string = data.headers.get("Content-Type");

        const blob = new Blob([data.body], { type: fileType });
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = fileMeta;
        a.click();

        window.URL.revokeObjectURL(url);

    }

    uploadPdf(id: number, check: string, OrgKey?: string) {
        var matterNo = sessionStorage.getItem("matterId");
        var accessToken = sessionStorage.getItem(environment.ACCESS_TOKEN_KEY);
        var apiBaseUrl = sessionStorage.getItem(environment.API_ENDPOINT);

        let url = `${this.baseURL}/upload-pdf?id=${id}&check=${check}&accessToken=${accessToken}&apiBaseUrl=${apiBaseUrl}`;

        if (matterNo != null && matterNo != "undefined") {
            url += `&matterNo=${matterNo}`;
        }

        if (OrgKey) {
            url += `&OrgKey=${OrgKey}`;
        }

        return this.dataService.get<DocumentUploadResponse>(url);
    }

    uploadPdfs(referralContacts: ReferralContact[]) {
        var accessToken = sessionStorage.getItem(environment.ACCESS_TOKEN_KEY);
        return this.dataService.post<boolean>(`${this.baseURL}/upload-pdfs?&accessToken=${accessToken}`, referralContacts)
    }

    getDocuments(): Observable<ActionDocuments[]> {
        var orgkey = sessionStorage.getItem(environment.ACTIONSTEP_ORG_KEY);
        var actionId = sessionStorage.getItem(environment.MATTER_NO);
        return this.dataService.get<ActionDocuments[]>(`${this.baseURL}/action-documents?actionId=${actionId}&orgKey=${orgkey}`);
    }
}
